import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-visa-modal',
    templateUrl: './visa-modal.component.html',
    styleUrls: ['./visa-modal.component.scss'],
    standalone: false
})
export class VisaModalComponent implements OnInit {

  constructor( private modalService: NgbModal) { }

  ngOnInit(): void {
  }
  close() {
    this.modalService.dismissAll()
  }
  
}
